/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MarkupPriorityResponse
 */
export interface MarkupPriorityResponse {
    /**
     * 
     * @type {string}
     * @memberof MarkupPriorityResponse
     */
    code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MarkupPriorityResponse
     */
    value?: number;
}

export function MarkupPriorityResponseFromJSON(json: any): MarkupPriorityResponse {
    return MarkupPriorityResponseFromJSONTyped(json, false);
}

export function MarkupPriorityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupPriorityResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function MarkupPriorityResponseToJSON(value?: MarkupPriorityResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'value': value.value,
    };
}


